import AsyncStorage from "@react-native-async-storage/async-storage";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  ActivityIndicator,
  Image,
  Pressable,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { FormattedMessage } from "react-intl";

import { toast } from "../../utils/toast";

import api from "../../services/api";
import { styles } from "./styles";

const BankAccountList = ({ onSelect }) => {
  const navigation = useNavigation();

  const [activeIndex, setActiveIndex] = useState(0);
  const [cards, setCards] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const ref = useRef(null);
  const isFocused = useIsFocused();

  useEffect(() => {
    getDataAccounts();
  }, [isFocused]);

  async function getDataAccounts() {
    setIsLoading(true);
    const token = await AsyncStorage.getItem("JWT_TOKEN");

    api
      .get("/bank-accounts", { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => {
        var accounts = [];

        res.data.data.map((item) => {
          accounts.push({
            bank: item.bank.bank,
            bankId: item.bank.id,
            typeAccount: item.bank_account_type.name,
            typeAccountId: item.bank_account_type_id,
            agency: item.branch,
            account: item.account,
            id: item.id,
          });
        });

        setCards(accounts);
        setIsLoading(false);
      })
      .catch(() => {
        toast(
          <FormattedMessage id="bankAccountList.erroCarregaDados" />,
          "#DA1414"
        );
        setIsLoading(false);
      });
  }

  const renderItem = useCallback(({ item, index }) => {
    return (
      <Pressable onPress={() => onSelect(item)} style={styles.contentCard}>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccountList.txtBanco" />{" "}
          <Text style={styles.textDescription}>{item.bank}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccountList.txtTipoConta" />{" "}
          <Text style={styles.textDescription}>{item.typeAccount}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccountList.txtAgencia" />{" "}
          <Text style={styles.textDescription}>{item.agency}</Text>
        </Text>
        <Text style={styles.textInfo}>
          <FormattedMessage id="bankAccountList.txtConta" />{" "}
          <Text style={styles.textDescription}>{item.account}</Text>
        </Text>
      </Pressable>
    );
  }, []);

  return (
    <>
      {isLoading ? (
        <ActivityIndicator
          color="#2797A2"
          size="large"
          style={{ marginTop: 10 }}
        />
      ) : (
        <View style={{ alignSelf: "center" }}>
          {cards.length === 0 ? (
            <Text style={styles.textNotFoundAccounts}>
              <FormattedMessage id="bankAccountList.txtNenhumaContaEncontrada" />
            </Text>
          ) : (
            <View style={{ alignSelf: "center" }}>
              {cards.map((item, index) => (
                <Pressable
                  key={index}
                  onPress={() => onSelect(item)}
                  style={styles.contentCard}
                >
                  <Text style={styles.textInfo}>
                    <FormattedMessage id="bankAccountList.txtBanco" />{" "}
                    <Text style={styles.textDescription}>{item.bank}</Text>
                  </Text>
                  <Text style={styles.textInfo}>
                    <FormattedMessage id="bankAccountList.txtTipoConta" />{" "}
                    <Text style={styles.textDescription}>
                      {item.typeAccount}
                    </Text>
                  </Text>
                  <Text style={styles.textInfo}>
                    <FormattedMessage id="bankAccountList.txtAgencia" />{" "}
                    <Text style={styles.textDescription}>{item.agency}</Text>
                  </Text>
                  <Text style={styles.textInfo}>
                    <FormattedMessage id="bankAccountList.txtConta" />{" "}
                    <Text style={styles.textDescription}>{item.account}</Text>
                  </Text>
                </Pressable>
              ))}
            </View>
          )}

          <View style={styles.container}>
            <TouchableOpacity
              style={styles.btnAdd}
              onPress={() => navigation.navigate("NewBankAccount")}
            >
              <Image
                style={styles.addIcon}
                source={require("../../../assets/add_icon.svg")}
              />
              <Text style={styles.textBtn}>
                <FormattedMessage id="bankAccount.adicionarConta" />
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      )}
    </>
  );
};

export default BankAccountList;
